export default __webpack_public_path__ + "static/coin_red-3bd744d844669d1909a83b5295047bf4.png";